module.exports = __webpack_public_path__ + "media/customizations/harvestlife/logo-new-da152303860895bf24196ae88be47509.png";